import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { EMPTY_LIST } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { Link } from '../../../Link'
import { getViewingProfileLink } from '../../../RentalPortalViewing'
import Text from '../../../Text'
import { Widget } from '../../../Widget'
import { useViewingProfileContext } from '../RentalPortalViewingProfile.hooks'
import { getViewingProfileTimeLabel } from '../RentalPortalViewingProfile.utils'

import { QA_NAME_VIEWING_PROFILE_RESCHEDULE_HISTORY } from './RentalPortalViewingProfileRescheduleHistory.constants'

import * as styles from './RentalPortalViewingProfileRescheduleHistory.module.css'

function RentalPortalViewingProfileRescheduleHistory({ locale, timezone }) {
  const { t } = useTranslation()

  const { isInitiated, viewingData } = useViewingProfileContext()

  const history = viewingData?.reschedule_history ?? EMPTY_LIST

  return isEmpty(history) ? null : (
    <Widget
      {...getQaSelector({ value: QA_NAME_VIEWING_PROFILE_RESCHEDULE_HISTORY })}
      contentContainerProps={{ className: styles.content }}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated}
      title={t('RentalPortal.ViewingProfileRescheduleHistoryTitleKey')}
    >
      {history.map(item => (
        <div className={styles.row} key={item.id}>
          <Text isSecondary>
            {getViewingProfileTimeLabel({
              locale,
              timezone,
              viewingData: item,
            })}
          </Text>
          <Link to={getViewingProfileLink(item.id)}>
            {t('RentalPortal.ViewingProfileRescheduleHistoryOpenKey')}
          </Link>
        </div>
      ))}
    </Widget>
  )
}

export default RentalPortalViewingProfileRescheduleHistory
